const METHOD_LOCK_CODES = ['allocation_method_locked_approved_cycle', 'allocation_method_locked_submeter_history'];
export const METHOD_LOCK_TOAST_TITLE = 'Allocation method not changed';
export const getMethodLockRefusal = asyncModel => {
  var _error$errorResp$titl, _error$errorResp;
  const error = asyncModel === null || asyncModel === void 0 ? void 0 : asyncModel.error;
  if (!error || !METHOD_LOCK_CODES.includes(error.errorCode)) return null;
  return (_error$errorResp$titl = (_error$errorResp = error.errorResp) === null || _error$errorResp === void 0 ? void 0 : _error$errorResp.title) !== null && _error$errorResp$titl !== void 0 ? _error$errorResp$titl : null;
};